// Mock data for tenants
export const mockTenantData = [
  {
    id: 1,
    namaTenant: "PT ABC Corporation",
    domainUnik: "abc-corp.com",
    email: "admin@abc-corp.com",
    nomorTelepon: "+62 812-3456-7890",
    alamat: "Jl. Sudirman No. 123, Jakarta Pusat",
    status: "Active",
    subscriptionPlan: "Advance",
    tanggalMulai: "2024-01-01",
    tanggalBerakhir: "2024-12-31",
    gracePeriod: 7,
    diskon: 10,
    lampiran: "contract_abc.pdf",
    remark: "Client premium dengan diskon khusus",
    pics: [
      {
        id: 1,
        nama: "John Doe",
        nomorTelepon: "+62 812-3456-7890",
        email: "john.doe@abc-corp.com"
      },
      {
        id: 2,
        nama: "Jane Smith",
        nomorTelepon: "+62 813-9876-5432",
        email: "jane.smith@abc-corp.com"
      }
    ]
  },
  {
    id: 2,
    namaTenant: "CV XYZ Solutions",
    domainUnik: "xyz-solutions.co.id",
    email: "contact@xyz-solutions.co.id",
    nomorTelepon: "+62 813-9876-5432",
    alamat: "Jl. Thamrin No. 456, Jakarta Selatan",
    status: "Active",
    subscriptionPlan: "Basic",
    tanggalMulai: "2024-02-15",
    tanggalBerakhir: "2025-02-14",
    gracePeriod: 3,
    diskon: 0,
    lampiran: "contract_xyz.pdf",
    remark: "Client baru dengan paket basic",
    pics: [
      {
        id: 3,
        nama: "Alice Johnson",
        nomorTelepon: "+62 813-9876-5432",
        email: "alice.johnson@xyz-solutions.co.id"
      }
    ]
  },
  {
    id: 3,
    namaTenant: "PT DEF Technologies",
    domainUnik: "def-tech.id",
    email: "info@def-tech.id",
    nomorTelepon: "+62 814-1111-2222",
    alamat: "Jl. Gatot Subroto No. 789, Jakarta Barat",
    status: "Non Active",
    subscriptionPlan: "Advance",
    tanggalMulai: "2023-06-01",
    tanggalBerakhir: "2024-05-31",
    gracePeriod: 14,
    diskon: 15,
    lampiran: "contract_def.pdf",
    remark: "Subscription expired, perlu renewal",
  },
  {
    id: 4,
    namaTenant: "PT Wayne Tech",
    domainUnik: "wayne-tech.com",
    email: "wayne@tech.com",
    nomorTelepon: "+62 814-2455-5231",
    alamat: "Jl. Larangan No. 45, Jakarta Selatan",
    status: "Active",
    subscriptionPlan: "Basic",
    tanggalMulai: "2024-06-01",
    tanggalBerakhir: "2026-05-31",
    gracePeriod: 14,
    diskon: 15,
    lampiran: "contract_def.pdf",
    remark: "Subscription expired, perlu renewal",
  },
  {
    id: 5,
    namaTenant: "Arknights Inc",
    domainUnik: "arknights.com",
    email: "arknights@inc.com",
    nomorTelepon: "+62 814-2455-5231",
    alamat: "Jl. Gatot Subroto No. 789, Jakarta Barat",
    status: "Active",
    subscriptionPlan: "Advance",
    tanggalMulai: "2025-06-01",
    tanggalBerakhir: "2026-05-31",
    gracePeriod: 7,
    diskon: 15,
    lampiran: "contract_def.pdf",
    remark: "Gaas",
  },
  {
    id: 6,
    namaTenant: "PT Nimbus",
    domainUnik: "nimbus.id",
    email: "admin@nimbus.id",
    nomorTelepon: "+62 812-1000-0006",
    alamat: "Jl. Melati No. 6, Bandung",
    status: "Active",
    subscriptionPlan: "Basic",
    tanggalMulai: "2024-03-01",
    tanggalBerakhir: "2025-03-01",
    gracePeriod: 5,
    diskon: 0,
    lampiran: "contract_nimbus.pdf",
    remark: "",
  },
  {
    id: 7,
    namaTenant: "PT Solaris",
    domainUnik: "solaris.co.id",
    email: "support@solaris.co.id",
    nomorTelepon: "+62 812-1000-0007",
    alamat: "Jl. Kenanga No. 7, Surabaya",
    status: "Active",
    subscriptionPlan: "Advance",
    tanggalMulai: "2024-04-01",
    tanggalBerakhir: "2025-04-01",
    gracePeriod: 10,
    diskon: 5,
    lampiran: "contract_solaris.pdf",
    remark: "",
  },
  {
    id: 8,
    namaTenant: "PT Aurora",
    domainUnik: "aurora.com",
    email: "hello@aurora.com",
    nomorTelepon: "+62 812-1000-0008",
    alamat: "Jl. Mawar No. 8, Medan",
    status: "Non Active",
    subscriptionPlan: "Basic",
    tanggalMulai: "2023-04-01",
    tanggalBerakhir: "2024-03-31",
    gracePeriod: 7,
    diskon: 0,
    lampiran: "contract_aurora.pdf",
    remark: "Expired",
  },
  {
    id: 9,
    namaTenant: "PT Zenith",
    domainUnik: "zenith.id",
    email: "contact@zenith.id",
    nomorTelepon: "+62 812-1000-0009",
    alamat: "Jl. Anggrek No. 9, Yogyakarta",
    status: "Active",
    subscriptionPlan: "Advance",
    tanggalMulai: "2024-05-01",
    tanggalBerakhir: "2025-05-01",
    gracePeriod: 14,
    diskon: 20,
    lampiran: "contract_zenith.pdf",
    remark: "VIP",
  },
  {
    id: 10,
    namaTenant: "PT Orion",
    domainUnik: "orion.co",
    email: "admin@orion.co",
    nomorTelepon: "+62 812-1000-0010",
    alamat: "Jl. Sakura No. 10, Bali",
    status: "Active",
    subscriptionPlan: "Basic",
    tanggalMulai: "2024-06-01",
    tanggalBerakhir: "2025-06-01",
    gracePeriod: 3,
    diskon: 0,
    lampiran: "",
    remark: "",
  },
  {
    id: 11,
    namaTenant: "PT Polaris",
    domainUnik: "polaris.com",
    email: "info@polaris.com",
    nomorTelepon: "+62 812-1000-0011",
    alamat: "Jl. Teratai No. 11, Malang",
    status: "Active",
    subscriptionPlan: "Advance",
    tanggalMulai: "2024-07-01",
    tanggalBerakhir: "2025-07-01",
    gracePeriod: 5,
    diskon: 8,
    lampiran: "",
    remark: "",
  },
  {
    id: 12,
    namaTenant: "PT Helios",
    domainUnik: "helios.id",
    email: "contact@helios.id",
    nomorTelepon: "+62 812-1000-0012",
    alamat: "Jl. Dahlia No. 12, Semarang",
    status: "Non Active",
    subscriptionPlan: "Basic",
    tanggalMulai: "2023-07-01",
    tanggalBerakhir: "2024-06-30",
    gracePeriod: 7,
    diskon: 0,
    lampiran: "",
    remark: "Expired",
  },
];

// Mock data for users
export const mockUserData = [
  {
    id: 1,
    nama: "masha",
    email: "masha@company.com",
    role: "Admin",
    status: "Active",
    tanggalDibuat: "2024-01-15",
    password: "default123",
  },
  {
    id: 2,
    nama: "Bernard",
    email: "Bernard@company.com",
    role: "User",
    status: "Active",
    tanggalDibuat: "2024-02-20",
    password: "default123",
  },
  {
    id: 3,
    nama: "Ramski",
    email: "Ramski@company.com",
    role: "Manager",
    status: "Non Active",
    tanggalDibuat: "2024-01-10",
    password: "default123",
  },
  {
    id: 4,
    nama: "Alam",
    email: "Alam@company.com",
    role: "User",
    status: "Active",
    tanggalDibuat: "2024-03-05",
    password: "default123",
  },
  {
    id: 5,
    nama: "Ndud",
    email: "ndud@company.com",
    role: "Admin",
    status: "Active",
    tanggalDibuat: "2024-01-01",
    password: "default123",
  },
  {
    id: 6,
    nama: "Satria",
    email: "satria@company.com",
    role: "User",
    status: "Active",
    tanggalDibuat: "2024-03-12",
    password: "default123",
  },
  {
    id: 7,
    nama: "Laras",
    email: "laras@company.com",
    role: "Manager",
    status: "Active",
    tanggalDibuat: "2024-03-14",
    password: "default123",
  },
  {
    id: 8,
    nama: "Bimo",
    email: "bimo@company.com",
    role: "User",
    status: "Non Active",
    tanggalDibuat: "2024-03-18",
    password: "default123",
  },
  {
    id: 9,
    nama: "Citra",
    email: "citra@company.com",
    role: "Admin",
    status: "Active",
    tanggalDibuat: "2024-04-01",
    password: "default123",
  },
  {
    id: 10,
    nama: "Dita",
    email: "dita@company.com",
    role: "User",
    status: "Active",
    tanggalDibuat: "2024-04-11",
    password: "default123",
  },
  {
    id: 11,
    nama: "Hendra",
    email: "hendra@company.com",
    role: "Manager",
    status: "Active",
    tanggalDibuat: "2024-04-20",
    password: "default123",
  },
  {
    id: 12,
    nama: "Indra",
    email: "indra@company.com",
    role: "User",
    status: "Active",
    tanggalDibuat: "2024-05-05",
    password: "default123",
  },
];

// Validation functions
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateDomain = (domain) => {
  const domainRegex = /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  return domainRegex.test(domain);
};

export const checkDomainUniqueness = (domain, currentTenantId, tenants) => {
  return !tenants.some(
    (tenant) => tenant.domainUnik === domain && tenant.id !== currentTenantId
  );
};

export const checkEmailUniqueness = (email, currentUserId, users) => {
  return !users.some(
    (user) => user.email === email && user.id !== currentUserId
  );
};

// Mock data for packages (Master Package)
export const mockPackages = [
  {
    id: 101,
    name: "Basic Plan",
    defaultPrice: 50000,
    benefits: ["Up to 10 users", "Basic support", "5GB storage"],
  },
  {
    id: 102,
    name: "Advance Plan",
    defaultPrice: 100000,
    benefits: ["Up to 50 users", "Priority support", "50GB storage", "Advanced analytics"],
  }
];

// Function to check subscription status
export const getSubscriptionStatus = (tanggalBerakhir, gracePeriod) => {
  const endDate = new Date(tanggalBerakhir);
  const graceEndDate = new Date(endDate);
  graceEndDate.setDate(graceEndDate.getDate() + gracePeriod);
  const today = new Date();

  if (today > graceEndDate) {
    return "expired";
  } else if (today > endDate) {
    return "grace_period";
  } else {
    return "active";
  }
};
